'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Button = require('@narvar/nth-block-button');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Divider = require('@narvar/nth-bit-divider');
var ViewWrapper = require('../../components/ViewWrapper.js');
var ClaimsList = require('./ClaimsList/ClaimsList.js');
var nthHookLoma = require('@narvar/nth-hook-loma');
var SessionContext = require('../../../../common/providers/SessionContext.js');
var Loading = require('../../../../common/components/Loading.js');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var IframeHeight = require('../../components/IframeHeight.js');
var VisuallyHidden = require('../../../../common/components/VisuallyHidden.js');
var RequiresPermission = require('../../providers/permissions/RequiresPermission.js');
var Box = require('../../../../common/components/layout/Box/Box.js');
var OrderLookupField = require('./OrderLookupField/OrderLookupField.js');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const OrderClaims = () => {
  const titan = useTitanAnalytics["default"]();
  const {
    claimsOrderClaimsStartClaimButton,
    claimsOrderClaimsLoading,
    claimsOrderClaimsOverviewHeader
  } = nthHookTranslations.useTranslations();
  const {
    orderNumber,
    retailerMoniker,
    localeCountry,
    localeLanguage,
    timezone,
    setOrderNumber
  } = SessionContext.useSession();
  const {
    navigateToOrderLookup
  } = AgentNavigatorProvider.useAgentNavigator();
  const [localOrderNumber, setLocalOrderNumber] = React.useState(orderNumber);
  const {
    data,
    loading
  } = nthHookLoma.useGetClaimsForOrderAgentQuery({
    fetchPolicy: 'network-only',
    variables: {
      orderNumber,
      retailerMoniker,
      localeLanguage,
      localeCountry,
      timezone
    }
  });
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'Order Overview'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    const {
      claims
    } = (data === null || data === void 0 ? void 0 : data.claimsForOrderAgent) ?? {};
    if (!loading) {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'products_list_viewed',
        properties: {
          list_id: 'order_claims',
          products: (claims ?? []).map(claim => ({
            product_id: claim.id,
            category: claim.claimType,
            variant: claim.status
          }))
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  }, [data, loading, titan]);
  return /*#__PURE__*/React__default["default"].createElement(ViewWrapper.ViewWrapperRoot, {
    contentScrollable: true
  }, /*#__PURE__*/React__default["default"].createElement(ViewWrapper.ViewWrapperContent, {
    contentScrollable: true
  }, /*#__PURE__*/React__default["default"].createElement(VisuallyHidden["default"], null, /*#__PURE__*/React__default["default"].createElement("h1", null, claimsOrderClaimsOverviewHeader)), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      maxWidth: '23rem',
      margin: '0 auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement(OrderLookupField["default"], {
    orderNumber: orderNumber,
    onChange: orderNumber => setLocalOrderNumber(orderNumber),
    onSubmit: () => {
      if (localOrderNumber) {
        setOrderNumber(localOrderNumber);
      }
    }
  }), /*#__PURE__*/React__default["default"].createElement(RequiresPermission["default"], {
    permission: "createClaim"
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    onClick: () => navigateToOrderLookup()
  }, claimsOrderClaimsStartClaimButton)))), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Loading["default"], {
    loading: !data && loading,
    text: claimsOrderClaimsLoading ?? ''
  }, /*#__PURE__*/React__default["default"].createElement(ClaimsList["default"], {
    claims: data === null || data === void 0 ? void 0 : data.claimsForOrderAgent.claims
  })))), /*#__PURE__*/React__default["default"].createElement(ViewWrapper.ViewWrapperBottomBar, null));
};
const OrderClaimsWithViewRoot = () => /*#__PURE__*/React__default["default"].createElement(IframeHeight["default"], {
  height: IframeHeight.IFRAME_HEIGHT.SHORT
}, /*#__PURE__*/React__default["default"].createElement(OrderClaims, null));
var OrderOverview = nthHookTranslations.withTranslationsProvider(OrderClaimsWithViewRoot, {
  translationKeys: ['claimsOrderClaimsStartClaimButton', 'claimsOrderClaimsLoading', 'claimsOrderClaimsOverviewHeader']
});

exports["default"] = OrderOverview;
